module.exports = __webpack_public_path__ + "media/images/common/favicon-8b8f3f72239df57ba3b75173cb6cb4aa.png";